@file:Suppress("ktlint:standard:no-wildcard-imports")

package xyz.malefic.multipage.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.fa.FaEnvelope
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import xyz.malefic.multipage.i18n.t
import xyz.malefic.multipage.styles.Theme

@Composable
fun StickyContactBar() {
    Box(
        modifier =
            Modifier
                .fillMaxWidth()
                .position(Position.Fixed)
                .bottom(0.px)
                .left(0.px)
                .zIndex(Theme.ZIndexSticky + 1)
                .backgroundColor(Theme.Primary)
                .boxShadow(offsetY = (-2).px, blurRadius = 12.px, color = rgba(0, 0, 0, 0.15f))
                .cursor(Cursor.Pointer)
                .onClick {
                    js("window.location.href = 'mailto:info@livstayjapan.co.jp'")
                },
        contentAlignment = Alignment.Center,
    ) {
        Row(
            modifier =
                Modifier
                    .padding(topBottom = 14.px, leftRight = 24.px)
                    .gap(12.px),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Box(
                modifier =
                    Modifier
                        .color(Theme.Surface)
                        .fontSize(16.px),
            ) {
                FaEnvelope()
            }
            SpanText(
                text = t("cta.email"),
                modifier =
                    Modifier
                        .color(Theme.Surface)
                        .fontWeight(FontWeight.Bold)
                        .fontSize(15.px)
                        .letterSpacing(1.px),
            )
            SpanText(
                text = "info@livstayjapan.co.jp",
                modifier =
                    Modifier
                        .classNames("ls-sticky-email")
                        .color(rgba(255, 255, 255, 0.7f))
                        .fontSize(13.px),
            )
        }
    }
}
